import React from 'react'
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Collapse from '@mui/material/Collapse';
import Box from '@mui/material/Box';
import { CardActionArea } from '@mui/material';
import Typography from '@mui/material/Typography';
import { Modal, IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';
// import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import { CircularProgressbarWithChildren } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { BiBorderRadius } from 'react-icons/bi';

ChartJS.register(ArcElement, Tooltip, Legend,);


const ExpandMore = styled((props) => {
    const { expand, ...other } = props;
    return <IconButton {...other} />;
})(({ theme, expand }) => ({
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
    }),
}));
const DummyScoreCard = () => {


    const percentage = 66;
    const weekData = [
        { date: "Saturday 3rd Feb", percentage: 77, week: "4th Week", color: "#00BF2A", title: 'New' },
        { date: "Sunday 4th Feb", percentage: 68, week: "4th Week", color: "#7400C2", title: "Meet With Customer" },
        { date: "Monday 5th Feb", percentage: 83, week: "5th Week", color: "#ED7DB1", title: 'Showing Homes' },
        { date: "Tuesday 6th Feb", percentage: 45, week: "5th Week", color: "#6EA478", title: "Submitting Offers" },
        { date: "Wednesday 7th Feb", percentage: 59, week: "5th Week", color: "#4C489B", title: "Under Contract" },
        { date: "Thursday 8th Feb", percentage: 51, week: "5th Week", color: "#6691CB", title: "BamFam" },
        { date: "Friday 9th Feb", percentage: 76, week: "5th Week", color: "#FDCA40", title: "Nurture Before Sale" },
        { date: "Monday 7th Feb", percentage: 83, week: "5th Week", color: "#F17105", title: "Sale Closed" },
        { date: "Tuesday 8th Feb", percentage: 45, week: "5th Week", color: "#9B5B5B", title: "Nurture After Sale" },
        { date: "Wednesday 9th Feb", percentage: 29, week: "5th Week", color: "#ED0423", title: "Rejected" },
        { date: "Thursday 10th Feb", percentage: 91, week: "5th Week", color: "#6691CB", title: "BamFam" },
        { date: "Friday 11th Feb", percentage: 76, week: "5th Week", color: "#00BF2A", title: 'New' },
    ];

    const [expanded, setExpanded] = React.useState(false);
    const handleExpandClick = () => {
        setExpanded(!expanded);
    };

    // pie chart
    const data = {
        labels: [
            'New',
            'Appointment Set',
            'Met With Customers',
            'Showing Homes',
            'Submitting Offers',
            'Under Contract',
            'BAMFAM',
            'Nurture Before ale',
            'Sale Closed',
            'Nurture Ater Sale',
            'Rejected',
        ],
        datasets: [{
            label: 'pie chart',
            data: [50, 50, 100, 100, 60, 100, 50, 100, 80, 60],
            backgroundColor: [
                '#121212',
                '#00BF2A',
                '#7400C2',
                '#ED7DB1',
                '#6EA478',
                '#4C489B',
                '#6691CB',
                '#FDCA40',
                '#F17105',
            ],
            borderColor: [
                '#121212',
                '#00BF2A',
                '#7400C2',
                '#ED7DB1',
                '#6EA478',
                '#4C489B',
                '#6691CB',
                '#FDCA40',
                '#F17105',
            ],

        }]
    };

    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'right',
                display: false,
                labels: {
                    display: false,
                    font: {
                        size: 11,
                        weight: 'bold',
                    },

                },
            },
            tooltip: {
                enabled: true,
            },
        }

    };

    const statusWithPercents = [
        {
            dot: '●',
            name: '  New',
            percent: '5%',
            leads: '53 Leads',
            nameColor: '#1E1B39',
            leadColor: '#1E1B39',
        },
        {
            dot: '●',
            name: '  Appointment Set',
            percent: '10%',
            leads: '51 Leads',
            nameColor: '#00BF2A',
            leadColor: '#00BF2A',
        },
        {
            dot: '●',
            name: '  Met With Customers',
            percent: '15%',
            leads: '20 Leads',
            nameColor: '#7400C2',
            leadColor: '#7400C2',

        },
        {
            dot: '●',
            name: '  Showing Homes',
            percent: '20%',
            leads: '20 Leads',
            nameColor: '#ED7DB1',
            leadColor: '#ED7DB1',
        },
        {
            dot: '●',
            name: '  Submitting Offers',
            percent: '25%',
            leads: '40 Leads',
            nameColor: '#6EA478',
            leadColor: '#6EA478',
        },
        {
            dot: '●',
            name: '  Under Contract',
            percent: '30%',
            leads: '20 Leads',
            nameColor: '#4C489B',
            leadColor: '#4C489B',
        },
        {
            dot: '●',
            name: '  BAMFAM',
            percent: '35%',
            leads: '50 Leads',
            nameColor: '#6691CB',
            leadColor: '#6691CB',
        },
        {
            dot: '●',
            name: ' Nurture Before Sale',
            percent: '40%',
            leads: '60 Leads',
            nameColor: '#FDCA40',
            leadColor: '#FDCA40',
        },
        {
            dot: '●',
            name: '  Sale Closed',
            percent: '45%',
            leads: '70 Leads',
            nameColor: '#F17105',
            leadColor: '#F17105',
        },
        {
            dot: '●',
            name: '  Nurture After Sale',
            percent: '50%',
            leads: '80 Leads',
            nameColor: '#9B5B5B',
            leadColor: '#9B5B5B',
        },
        {
            dot: '●',
            name: '  Rejected',
            percent: '55%',
            leads: '60 Leads',
            nameColor: '#ED0423',
            leadColor: '#ED0423',
        }
    ]

    return (
        <div>
            <div style={{ display: 'grid', justifyContent: 'center' }}>
                <Card sx={{ width: 1021, mt: 2 }}>
                    <CardActions disableSpacing>
                        <Box style={{ display: 'flex', margin: '15px' }}>
                            <Typography style={{ fontSize: '25px', fontWeight: '700', color: '#414D55' }}>Score of Agent</Typography>
                        </Box>
                        <IconButton aria-label="share"></IconButton>
                        <ExpandMore expand={expanded} onClick={handleExpandClick} aria-expanded={expanded} aria-label="show more">
                            <Typography style={{ color: '#5379BD', fontSize: '16px', fontWeight: '700' }}>View All</Typography>
                        </ExpandMore>
                    </CardActions>
                    <Box style={{ display: 'flex', justifyContent: 'center' }}>
                        {/* <div style={{ width: 200, height: 200 }}>
                  <CircularProgressbar value={percentage} text={`${percentage}%`} />
              </div> */}
                        <div style={{ display: 'flex', flexWrap: 'wrap', margin: '10px', justifyContent: 'space-around' }}>
                            {weekData.slice(0, 4).map((data, index) => (
                                <div key={index} style={{ margin: 20, width: 200, height: 200 }}>
                                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                                        <span style={{ fontSize: '18px', fontWeight: 'bold' }}>{data.title}</span>
                                    </div>
                                    <CircularProgressbarWithChildren
                                        styles={{
                                            path: {
                                                stroke: data.color,
                                                transition: 'stroke-dashoffset 0.5s ease 0s',
                                            },
                                            trail: {
                                                stroke: '#d6d6d6',
                                            },
                                            text: {
                                                fill: '#f88',
                                                fontSize: '16px',
                                            },
                                        }}
                                        value={data.percentage}>
                                        <div style={{ display: 'grid', placeItems: 'center' }}>
                                            <strong>{data.date}</strong>
                                            <strong>{data.percentage}%</strong>
                                            <strong>{data.week}</strong>
                                        </div>
                                    </CircularProgressbarWithChildren>
                                </div>
                            ))}
                        </div>
                    </Box>


                    {!expanded && (
                        <CardContent>
                            <div style={{ display: 'flex', flexWrap: 'wrap', margin: '10px', justifyContent: 'space-around' }}>
                                {weekData.slice(4).map((data, index) => (
                                    <div key={index} style={{ margin: 20, width: 200, height: 200 }}>
                                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                                            <span style={{ fontSize: '18px', fontWeight: 'bold' }}>{data.title}</span>
                                        </div>
                                        <CircularProgressbarWithChildren
                                            styles={{
                                                path: {
                                                    stroke: data.color,
                                                    transition: 'stroke-dashoffset 0.5s ease 0s',
                                                },
                                                trail: {
                                                    stroke: '#d6d6d6',
                                                },
                                                text: {
                                                    fill: '#f88',
                                                    fontSize: '16px',
                                                },
                                            }}
                                            value={data.percentage}>
                                            <div style={{ display: 'grid', placeItems: 'center' }}>
                                                <strong>{data.date}</strong>
                                                <strong>{data.percentage}%</strong>
                                                <strong>{data.week}</strong>
                                            </div>
                                        </CircularProgressbarWithChildren>
                                    </div>
                                ))}
                            </div>
                        </CardContent>
                    )}
                </Card>

                <Card sx={{ width: 1021, mt: 2 }}>
                    <div style={{display:'flex'}}>
                        <div style={{ width: '400px', height: '400px', marginTop: '20px', padding: '10px' }}>
                            <Pie data={data} options={options} />
                        </div>

                        <div style={{ margin: '30px auto' }}>
                            {/* <ul style={{ listStyle: 'none', padding: '0', display: 'flex', flexDirection: 'column', gap: '30px'  }}>
                                {statusWithPercents.map((status, index) => (
                                    <li key={index}>
                                        <div style={{ display: 'flex', gap: '50px', justifyContent: 'space-between' }}>
                                            <div >
                                                {status.name}
                                            </div>
                                            
                                            <div>
                                                <span style={{ fontWeight: 'bold' }}>
                                                    {status.percent}
                                                </span>
                                            </div>
                                          
                                            <div>
                                                <span >{status.leads}</span>
                                            </div>
                                           
                                        </div>
                                    </li>
                                ))}
                            </ul> */}
                            
                            <ul style={{
                                listStyle: 'none',
                                padding: '0',
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '30px',
                            }}>
                                {statusWithPercents.map((status, index) => (
                                    <li key={index}>
                                        <div style={{ display: 'flex', gap: '80px', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <div style={{ flex: 3, whiteSpace: 'nowrap' }}>
                                                <span style={{ color: status.nameColor }}>{status.dot}</span>   <span style={{ fontSize: '16px', fontWeight: 'bold', color:'#1E1B39'}}>{status.name}</span>
                                            </div>

                                            <div style={{ flex: 1, textAlign: 'right', whiteSpace: 'nowrap' }}>
                                                <span style={{ fontSize: '14px', fontWeight: 'bold', color:'#615E83' }}>
                                                    {status.percent}
                                                </span>
                                            </div>

                                            <div style={{ flex: 1, textAlign: 'right', whiteSpace: 'nowrap' }}>
                                                <span style={{ fontSize: '16px', fontWeight: 'bold', color: status.leadColor }}>{status.leads}</span>
                                            </div>

                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </Card>


            </div>


        </div>
    )
}

export default DummyScoreCard
